// extracted by mini-css-extract-plugin
module.exports = {"pd10":"index_pd10_3v38n","minHeight":"index_minHeight_2y219","anchor":"index_anchor_2MC-z","cancel":"index_cancel_3Rf4h","padding":"index_padding_apMiB"};